module.exports = __webpack_public_path__ + "static/img/cjx02.1c89e71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cjx02.png
// module id = 160
// module chunks = 0